<template>
  <div class="feed-item">
    <div class="body-wrapper">
      <div class="feed-content">
        <FeedHeader :feed="feed" :feedType="feedType" />
        <div class="feed-summary">{{ cutOutContent }}</div>
        <div class="link-wrapper">
          <a href="javascript:;" @click="viewDetail">查看详情</a>
        </div>
        <ArticleElement :feed="feed" />
      </div>
    </div>
    <div class="footer-wrapper">
      <FeedFooter :feed="feed" :feedType="feedType" />
    </div>
    <div>
      <el-dialog
        :visible.sync="dialogVisible"
        :show-close="false"
        custom-class="handlian-loading-detail"
        width="540px"
      >
        <div
          class="loading-feed-detail"
          v-loading="loading"
          element-loading-text="加载详情中"
          element-loading-spinner="el-icon-loading"
        ></div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { sliceFeedContent } from "../../../utils/feed";
import FeedHeader from "./feed-header";
import ArticleElement from "../../friend/feed-elements/article-element";
import FeedFooter from "./feed-footer";
import { apiMap } from "../../../utils/apiMap";
export default {
  name: "article-item",
  props: {
    feed: {
      type: Object,
      required: true,
    },
    page: Number,
  },
  data() {
    return {
      feedType: "1",
      loading: true,
      dialogVisible: false,
    };
  },
  components: {
    FeedHeader,
    ArticleElement,
    FeedFooter,
  },
  computed: {
    cutOutContent() {
      return sliceFeedContent(this.feed.content);
    },
  },
  methods: {
    viewDetail() {
      const initUserSign = {
        feedPage: 1,
        articlePage: this.page,
        albumPage: 1,
        audioPage: 1,
        videoPage: 1,
      };
      Store.dispatch("setUserCenterSign", initUserSign);
      // this.$router.push({
      //   path: "detail",
      //   query: { feedID: this.feed.id, feedType: this.feedType },
      // });
      let routerClanCard = this.$router.resolve({
        path: "detail",
        query: { feedID: this.feed.id, feedType: this.feedType },
      });
      window.open(routerClanCard.href, "_blank");
      return false;
      this.$bus.$emit("switch-list-detail", this.feed.id);
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      let _this = this;
      _this.dialogVisible = true;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["feedDetail"]["method"],
          url: apiMap["feedDetail"]["url"],
          params: {
            token: loginUser.token,
            modelId: _this.feed.id,
            modelType: 1,
            self: 2,
          },
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            setTimeout(() => {
              _this.dialogVisible = false;
              _this.$bus.$emit("switch-list-detail", response.data.result.data);
            }, 500);
          } else {
            _this.$message({
              message: "加载详情失败，稍后再试",
              duration: 1500,
              offset: 230,
            });
            _this.dialogVisible = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
.feed-item {
  margin-bottom: 15px;
  padding: 15px;
  background-color: #fff;
}

.feed-summary {
  line-height: 25px;
  white-space: pre-wrap;
}

.link-wrapper a {
  color: #1a70db;
}

.loading-feed-detail {
  height: 100px;
}
</style>
